import Button from "aldoo-ra/Button"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"

const Pagination = ({ currentPage, totalPages, onPageChange, className }) => {
  currentPage = parseInt(currentPage)

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return
    onPageChange(page)
  }

  if (currentPage === 0 || totalPages < 1) return null

  const pageButton = (page, isActive) => (
    <Button
      key={page}
      onClick={() => handlePageChange(page)}
      variant="nav_icon"
      className={isActive ? "text-text hover:primary" : "!text-text_secondary hover:!primary"}
    >
      {page}
    </Button>
  )

  // For 1-2 pages, show all page numbers directly
  if (totalPages <= 2) {
    return (
      <div className={className || "flex items-center justify-center gap-2 mt-10 lg:mt-[100px] xl:mt-[100px]"}>
        <Button
          variant="nav_icon"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeftIcon className="w-8 h-8 text-text_secondary pr-1" />
        </Button>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) =>
          pageButton(page, currentPage === page)
        )}

        <Button
          variant="nav_icon"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRightIcon className="w-8 h-8 text-text_secondary pl-1" />
        </Button>
      </div>
    )
  }

  // For 3+ pages: always show first and last, ellipsis around current page
  const showLeftEllipsis = currentPage > 2
  const showCurrentPage = currentPage !== 1 && currentPage !== totalPages
  const showRightEllipsis = currentPage < totalPages - 1

  return (
    <div className={className || "flex items-center justify-center gap-2 mt-10 lg:mt-[100px] xl:mt-[100px]"}>
      <Button
        variant="nav_icon"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeftIcon className="w-8 h-8 text-text_secondary pr-1" />
      </Button>

      {pageButton(1, currentPage === 1)}

      {showLeftEllipsis && <span className="text-text_secondary px-1">...</span>}

      {showCurrentPage && pageButton(currentPage, true)}

      {showRightEllipsis && <span className="text-text_secondary px-1">...</span>}

      {pageButton(totalPages, currentPage === totalPages)}

      <Button
        variant="nav_icon"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRightIcon className="w-8 h-8 text-text_secondary pl-1" />
      </Button>
    </div>
  )
}

export default Pagination